<template lang="pug">
  div#app.app-center-fe(v-if="showPage" ,:style="!isFixIosVoice?{marginTop:`calc(66px + ${isSafeAreaInsetTop} + 20pt)`}:{marginTop:`calc(74px + ${isSafeAreaInsetTop} + 20pt)`}")
    van-nav-bar(v-if="$route.matched.length > 1", :title="title",style='padding-top:20pt;')
      template(#left)
        img(src="@/assets/logo.png", class="logo", v-if='logoShow', @click='test()')
        van-icon(v-else, name="arrow-left", @click='backPage')
        //- van-
      template(#right)
        van-icon(name="cross", @click="closePage")
        //- van-icon( v-if='notProd', name="contact-o", @click="alertParam" style='right:40px;') 
    van-tabbar(v-if="tabShow && (loading === 'loaded') && faqShow", v-model="active")
      van-tabbar-item(v-if="userInfo.userInfo.accountType !== '1' && showInte === 'true'", to='/record', name='record', class="tab-hover")
        span {{$t('integral')}}
        template(#icon="props")
          img(:src="props.active ? tab1.active : tab1.inactive")
      //- van-tabbar-item(icon="point-gift-o", to='/giftcredits', class="tab-hover") 礼包
      //- van-tabbar-item(to='/store')
      //-   template(#icon="props")
      //-     img(class="tab_store", :src="props.active ? tab2.active : tab2.inactive")
      //- router-link(to="/store", class="tab_store")
      van-tabbar-item(v-if="faqVersion.extVal !== 'v2'", icon="service-o", to='/faq', name='faq', class="tab-hover", :badge="badge") {{$t('customerService')}}
      van-tabbar-item(v-if="showMine === 'true'", icon="contact", to='/user', name='user', class="tab-hover") {{$t('accountID')}}
    //- div  {{navBarPaddingTop}} {{isSafeAreaInsetTop}}
    router-view(v-if="faqShow")
    van-loading(v-if="faqShow===false", color="#E60012", vertical) {{$t('loading')}}
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import Vuei18n from "vue-i18n";
import { Dialog } from 'vant'
import {fixIosVoice,isSafeAreaInsetTop } from '@/utils/utils.js'
export default {
  name: 'Home',
  data(){
    return {
      userAgent: navigator.userAgent.toLowerCase(),
      tabShow: true,
      logoShow: true,
      // title: '',
      active: 'user',
      badge: null,
      showInte: "true",
      showMine: "true",
      faqShow: false,

      tab1: {
        active: require('./assets/jf_active.png'),
        inactive: require('./assets/jf.png')
      },
      tab2: {
        active: require('./assets/tab_store_active.png'),
        inactive: require('./assets/tab_store.png')
      },
      isFixIosVoice: fixIosVoice(),
      isSafeAreaInsetTop: isSafeAreaInsetTop(),
      // navBarPaddingTop:0
    }
  },
  created(){    
    const head = document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    link.href = `${CONFIG.utilsUrl}/css/mobile-init.css`
    link.rel = 'stylesheet'
    link.type = 'text/css'
    head.appendChild(link)
    console.log("当前版本01.17")
    window.getPlatAppInfo = this.getPlatAppInfo
    // window.webkit.messageHandlers.showToastForJS.postMessage('test1')
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getDeviceInfo.postMessage(null)
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getPlatAppInfo.postMessage(null)
    // window.webkit.messageHandlers.webClose.postMessage(null)
    // window.webkit.messageHandlers.showToastForJS.postMessage('test2')
    this.$store.commit('INIT', {
      uid: this.getCookiesObj() && this.getCookiesObj()['uid'] || '',
      deviceId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).deviceId || '',
      appId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).appId || '',
      cpUid: this.getCookiesObj() && this.getCookiesObj()['cpUid'] || '',
      token: this.getCookiesObj() && decodeURIComponent(this.getCookiesObj()['ntToken']) || '',
      phoneModel: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).phonePattern || '',
      clientPlat: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).clientPlat || '',
      channelId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).appChannel || '',
      roleName: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).roleName || '',
      serverName: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).serverName || '',
      areaId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).areaId || '1',
      roleId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).roleId || '',
      serverId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).serverId || '',
      uname: this.getCookiesObj() && this.getCookiesObj()['userName'] || '',
      lang: navigator.userAgent && (navigator.userAgent.split('/').length > 8) && navigator.userAgent.split('/')[9].split('=')[1],
      sdkVersion: navigator.userAgent && (navigator.userAgent.split('/').length > 7) && navigator.userAgent.split('/')[8].split('=')[1],
      apkVersion: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).apkVersion || '',
      loginTypes: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).loginTypes || '',
      isNewUploadLog: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).isNewUploadLog || '',
      uniqueId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).uniqueId || '',
    })
    // this.androidData = {
    //   uid: this.getCookiesObj() && this.getCookiesObj()['uid'] || '',
    //   deviceId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).deviceId || '',
    //   appId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).appId || '',
    //   cpUid: this.getCookiesObj() && this.getCookiesObj()['cpUid'] || '',
    //   token: this.getCookiesObj() && decodeURIComponent(this.getCookiesObj()['ntToken']) || '',
    //   phoneModel: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).phonePattern || '',
    //   clientPlat: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getDeviceInfo()).clientPlat || '',
    //   channelId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).appChannel || '',
    //   roleName: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).roleName || '',
    //   serverName: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).serverName || '',
    //   areaId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).areaId || '',
    //   roleId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).roleId || '',
    //   serverId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).serverId || '',
    //   uname: this.getCookiesObj() && this.getCookiesObj()['userName'] || '',
    //   lang: navigator.userAgent && (navigator.userAgent.split('/').length > 8) && navigator.userAgent.split('/')[9].split('=')[1],
    //   sdkVersion: navigator.userAgent && (navigator.userAgent.split('/').length > 7) && navigator.userAgent.split('/')[8].split('=')[1],
    //   apkVersion: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).apkVersion || '',
    //   loginTypes: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).loginTypes || '',
    //   isNewUploadLog: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getPlatAppInfo()).isNewUploadLog || '',
    //   uniqueId: typeof(ntAndroidWeb) !== 'undefined' && JSON.parse(ntAndroidWeb.getCpCustomParams()).uniqueId || '',
    // }
    // console.log(this.$md5('123456'))
    // this.$store.commit('INIT', {
    //   uid: '1851867384298602496',
    //   deviceId: '3ac0a2a406ffe48c82f345a07bcac78e42b6e8b0',
    //   appId: '1001',
    //   cpUid: '1111',
    //   token: 'pq_zJ-FtB18wMhP_po1mFrX1c0pZvWeuk7HoEHRvu2spg1gVSD0VlWpivyjJ6aj2bYJF9MJL9hOKPZVkdHOTzA==',
    //   phoneModel: 'iphone 7 plus',
    //   clientPlat: 'iOS',
    //   channelId: '1',
    //   uname: 'test',
    //   lang: 'en-US',
    //   roleName: 'buzhid',
    //   serverName: 'diyige',
    //   areaId: '1',
    //   roleId: '1',
    //   serverId: '1',
    //   loginTypes: ''
    // })
    this.active = this.$route.matched[1].path.split('/')[1]
    if(this.$route.matched.length > 1){
      // this.title = this.$t(this.$route.matched[0].name);
      if(this.$route.matched[1].path.split('/')[2] !== 'index'){
        this.logoShow = false
        if(this.$route.matched[1].path.split('/')[2] !== 'emailSubmit'){
          this.tabShow = false
        } else {
          this.logoShow = true
        }
        if(this.$route.matched[1].path.split('/')[2] !== 'checkEmail'){
          this.tabShow = false
        }
      }
    }
    // console.log(this.loading)
    // this.submitEvaluate(Qs.stringify({
    //   appId: 1001,
    //   uid: '1316711633531310080',
    //   deviceId: 'testIosDeviceId',
    //   accessToken: this.token,
    //   questionId: 18,
    //   isSolve: 2,
    //   isSatisfied: 1
    // }));
  },
  methods:{
    ...mapActions(['getUserInfo', 'getSwitchInfo']),
    ...mapActions('faq', ['getNewMsgNo', 'getFaqVersion']),
    alertParam (string) {
         let json = this.$store.getters
        Dialog.alert({
          title: '标题',
          // message:navigator.userAgent.toLowerCase()
          message: JSON.stringify({ deviceId: json.deviceId || '',
                  phoneModel: json.phonePattern || '',
                  clientPlat: json.clientPlat || '',
                  appId: json.appId || '',
                  channelId: json.appChannel || '',
                  roleName: json.roleName || '',
                  lang: json.lang || '',
                  serverName: json.serverName || '',
                  roleId: json.roleId || '',
                  serverId: json.serverId || '',
                  areaId: json.areaId || '1',
                  sdkVersion: json.sdkVersion || '1',
                  apkVersion: json.apkVersion || '1',
                  loginTypes: json.loginTypes || '',
                  isNewUploadLog: json.isNewUploadLog || '',
                  uniqueId: json.uniqueId || '',
                  isSafeAreaInsetTop :this.isSafeAreaInsetTop
                }),
                
        })
    },
    addMessageListener(){
      let that = this
      window.vuplex.addEventListener('message', function(event) {
        let json = JSON.parse(event.data);
        that.$store.commit('INIT', {
          deviceId: json.deviceId || '',
          phoneModel: json.phonePattern || '',
          clientPlat: json.clientPlat || '',
          appId: json.appId || '',
          channelId: json.appChannel || '',
          roleName: json.roleName || '',
          lang: json.lang || '',
          serverName: json.serverName || '',
          roleId: json.roleId || '',
          serverId: json.serverId || '',
          areaId: json.areaId || '1',
          sdkVersion: json.sdkVersion || '1',
          apkVersion: json.apkVersion || '1',
          loginTypes: json.loginTypes || '',
          isNewUploadLog: json.isNewUploadLog || '',
          uniqueId: json.uniqueId || '',
        })
        // > JSON received: { "type": "greeting", "message": "Hello from C#!" }
        console.log('JSON received: ' + json);
      });
    },
    getCookiesObj() { 
      return document.cookie.split(';').reduce((f, sv) => {
          let _sv = sv.trim().split('=').map(v => {
              return v.trim()
          })
          f[_sv[0]] = _sv[1]   
          return f  
      }, {})
    },
    backPage(){
      // console.log(this.$route.matched[1].path.split('/'))
      if(this.$route.matched[1].path.split('/')[2] === 'bindSuccess'){
        this.$router.push({
          path: '/user/index'
        });
      } else if(this.$route.matched[1].path.split('/')[1] === 'faq'){
        if(this.$route.matched[1].path.split('/')[2] === 'content'){
          this.$router.push({
            path: '/faq/index'
          });
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    closePage(){
      typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.webClose() || (window.vuplex && window.vuplex.postMessage({type: 'close', message: '关闭网页'})) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.webClose.postMessage(null))
    },
    getPlatAppInfo(ocData){
      this.$store.commit('INIT', {
        deviceId: JSON.parse(ocData).deviceId || '',
        phoneModel: JSON.parse(ocData).phonePattern || '',
        clientPlat: JSON.parse(ocData).clientPlat || '',
        appId: JSON.parse(ocData).appId || '',
        channelId: JSON.parse(ocData).appChannel || '',
        roleName: JSON.parse(ocData).roleName || '',
        lang: JSON.parse(ocData).lang || '',
        serverName: JSON.parse(ocData).serverName || '',
        roleId: JSON.parse(ocData).roleId || '',
        serverId: JSON.parse(ocData).serverId || '',
        areaId: JSON.parse(ocData).areaId || '',
        sdkVersion: JSON.parse(ocData).sdkVersion || '1',
        apkVersion: JSON.parse(ocData).apkVersion || '1',
        loginTypes: JSON.parse(ocData).loginTypes || '',
        isNewUploadLog: JSON.parse(ocData).isNewUploadLog || '',
        uniqueId: JSON.parse(ocData).uniqueId || '',
      })
      return ocData
    }
  },
  computed:{
    ...mapGetters(['errmsg', 'loading', 'userInfo', 'uid', 'deviceId', 'token', 'appid', 'lang', 'switchInfo', 'switching', 'channelId', 'uniqueId','showPage']),
    ...mapGetters('faq', ['errmsg', 'msgNo', 'loadingNO', 'faqVersion', 'fvLoading']),
    title: $vm => {
      return $vm.$t($vm.$route.matched[0].name)
    },
    notProd(){
      if(CONFIG&&CONFIG.baseUrl){
        return CONFIG.baseUrl.indexOf('dev') != -1 || CONFIG.baseUrl.indexOf('qa') != -1
      }
      return false
    },
    
  },
  mounted(){
    
    // window.webkit.messageHandlers.showToastForJS.postMessage(this.uniqueId)
    // alert(navigator.userAgent) 
    // alert(document.cookie) 
    // alert(typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.getDeviceInfo().join(''))
    // console.log(navigator.userAgent) 
    // console.log(document.cookie) 
    // console.log(typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.getDeviceInfo().join(''))
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(navigator.userAgent) 
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(document.cookie) 
    // typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.showToastForJS(JSON.stringify(this.androidData)) 
    // 改为在 updated 生命周期钩子中动态获取，确保 DOM 已渲染完成
    if(this.lang === 'ko-CN'){
      window.i18n.locale = 'ko-KR'
    } else {
      window.i18n.locale = this.lang
    }
    window.vuplex && window.vuplex.postMessage({type: 'getUserInfo', message: '初始化'})
    if (window.vuplex) {
        this.addMessageListener();
    } else {
        window.addEventListener('vuplexready', this.addMessageListener);
    }
    this.$watch('lang', val => {
      if(this.lang === 'ko-CN'){
        window.i18n.locale = 'ko-KR'
      } else {
        window.i18n.locale = this.lang
      }
    })
    this.$watch('appid', val => {
      if(typeof(ntAndroidWeb) == 'undefined'){
        if(val){
          if(this.lang === 'ko-CN'){
            window.i18n.locale = 'ko-KR'
          } else {
            window.i18n.locale = this.lang
          }
          if(this.deviceId && this.uid){
            this.getUserInfo(Qs.stringify({
              appId: this.appid,
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token
            }));
            this.getNewMsgNo(Qs.stringify({
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token
            }));
            this.getSwitchInfo({
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token,
              appId: this.appid,
              channelId: this.channelId,
              switchId: '11,12,13,22,26,27,28'
            })
          }
          this.getFaqVersion({
            appId: this.appid,
          })
        }
      }
    })
    this.$watch('deviceId', val => {
      if(typeof(ntAndroidWeb) !== 'undefined'){
        this.$store.commit('INIT', {
          uid: this.getCookiesObj() && this.getCookiesObj()['uid'] || '',
          cpUid: this.getCookiesObj() && this.getCookiesObj()['cpUid'] || '',
          token: this.getCookiesObj() && decodeURIComponent(this.getCookiesObj()['ntToken']) || '',
        })
        if(val){
          if(this.lang === 'ko-CN'){
            window.i18n.locale = 'ko-KR'
          } else {
            window.i18n.locale = this.lang
          }
          if(this.deviceId && this.uid){
            this.getUserInfo(Qs.stringify({
              appId: this.appid,
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token
            }));
            this.getNewMsgNo(Qs.stringify({
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token
            }));
            this.getSwitchInfo({
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token,
              appId: this.appid,
              channelId: this.channelId,
              switchId: '11,12,13,22,26,27,28'
            })
          }
          this.getFaqVersion({
            appId: this.appid,
          })
        }
      }
    })
    if(this.appid){
      this.getFaqVersion({
        appId: this.appid,
      })
    }
    if(this.uid && this.token && this.deviceId){
      if(this.lang === 'ko-CN'){
        window.i18n.locale = 'ko-KR'
      } else {
        window.i18n.locale = this.lang
      }
      this.getUserInfo(Qs.stringify({
        appId: this.appid,
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token
      }));
      this.getNewMsgNo(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token
      }));
      this.getSwitchInfo({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        channelId: this.channelId,
        switchId: '11,12,13,22,26,27,28'
      })
    }
    this.$watch(() => this.$route, val => {
      if(this.$route.matched.length > 1){
        this.title = this.$t(this.$route.matched[0].name);
        if(this.$route.matched[1].path.split('/')[2] !== 'index'){
          this.logoShow = false
          this.tabShow = false
        } else {
          this.logoShow = true
          this.tabShow = true
        }
        this.active = this.$route.matched[1].path.split('/')[1]
      }
    })
    this.$watch('fvLoading', val => {
      if(val === 'loaded'){
        if(this.faqVersion.extVal && this.faqVersion.extVal == 'v2'){
          if(this.$route.matched[1].path.split('/')[1] !== 'faq'){
            this.faqShow = true
          } else {
            if(this.$route.matched[1].path.split('/')[2] == 'index'){
              window.location.href = CONFIG.v2faqUrl + '/faq/1'
            } else if(this.$route.matched[1].path.split('/')[2] == 'emailSubmit'){
              window.location.href = CONFIG.v2faqUrl + '/faq/0'
            }
          }
        } else {
          this.faqShow = true
        }
      }
    })
    this.$watch('loadingNO', val => {
      if(val === 'loadedNo'){
        this.badge = this.msgNo.newMessageNumber || null;
      }
    })
    this.$watch('switchInfo', val => {
      if(this.switchInfo.switchInfoList && this.switchInfo.switchInfoList[11]){
        this.showInte = this.switchInfo.switchInfoList[11]
      }
      if(this.switchInfo.switchInfoList && this.switchInfo.switchInfoList[27]){
        this.showMine = this.switchInfo.switchInfoList[27]
      }
    })
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-bottom: 80px;
  margin-top:66px;
}
#app .van-nav-bar{
  z-index: 999;
}
.van-loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}
.van-loading__spinner--circular{
  top: 50%
}
.van-loading__text{
  position: relative;
  top: 50%;
  color: #E60012
}
.van-tabbar{
  z-index: 9999;
}
.van-nav-bar__right{
  .van-icon{
    font-size: 20px;
    position: absolute;
    padding: 10px;
    right: 10px;
    bottom: 4px;
  }
}
.van-nav-bar__left{
  .van-icon{
    font-size: 20px;
    position: absolute;
    padding: 10px;
    left: 10px;
    bottom: 4px;
  }
}

.logo{    
  height: 20px;
  bottom: 14px;
  position: absolute;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.van-toast{
  width: 128px;
}
.van-nav-bar{
  position: fixed;
  top:0;
  // top:env(safe-area-inset-top,0);
  // top:constant(safe-area-inset-top,0);
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
  // padding-top: constant(safe-area-inset-top,0);
  // padding-top: env(safe-area-inset-top,0);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: constant(safe-area-inset-left);
  padding-left: env(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-right: env(safe-area-inset-right);
  width: 100%;
  // top: 0;
  // top: 0;
}
.van-tabbar-item__icon img.tab_store{
  height: 60px;
  width: 60px;
  margin-top: -20px;
  display: block;
  z-index: 2;
}
.tab-hover:active{
    background-color: #eee;
}
body{
  background-color: #f7f7f7;
}
</style>
